var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Box',{attrs:{"className":"c-text-with-icon"}},[(_vm.tooltipText)?_c('Tooltip',{attrs:{"title":_vm.tooltipText}},[_c('Icon',{attrs:{"icon":_vm.icon,"className":"icon"}})],1):_c('Icon',{attrs:{"icon":_vm.icon,"className":"icon"}}),_c('Box',[_c('span',[_vm._v(_vm._s(_vm.text))]),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }